export const LogLevel = Object.freeze({
    Debug: 1,
    Info: 2,
    Warning: 3,
    Error: 4,
});